import LocalityDelete from './LocalityDelete'
export {LocalityDelete}
export default LocalityDelete
